import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core'
import moment from 'moment'
import {states} from '../../../core/helpers/states'
import * as _ from 'lodash'

@Component({
    selector: 'app-licensures',
    templateUrl: './licensures.component.html',
    styleUrls: ['./licensures.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LicensuresComponent implements OnInit {
  @Output() imgUrl: EventEmitter<string> = new EventEmitter()
  @Output() showLicense: EventEmitter<boolean> = new EventEmitter()
  @Output() licenseState: EventEmitter<string> = new EventEmitter()
  // imgUrl
  // showLicense
  // licenseState
  constructor() { }
  @Input() breakpoints: any = {
    small: false,
    extraSmall: false,
    medium: false,
    large: true,
    extraLarge: false
  }
  @Input() licensures: any
  ngOnInit(): void {
  }

  transformDateFormat(text: string, additionalDate: string): string {
    if (additionalDate === '-') {
      return 'N/A'
    }
    if (!text) {
      return 'N/A'
    }
    let convDate = ''
    const inputFormatYMD = 'YYYY-MM-DD'
    const formatMDY = 'MM/DD/YYYY'
    try {
      const w = text.split('-')
      if (w.length === 3) {
        convDate = `${w[1]}/${w[2]}/${w[0]}`
      }
    }
    catch (e) {}

    if (additionalDate) {
      convDate += '\n' + additionalDate
    }

    return convDate
  }

  // remove escaped delimiters (if need)
  transformSpaces(text: string): string {
    if (!text) {
      return 'N/A'
    }
    return text
    // return text.split('\\n').join('\n')
  }

  sortByNo(arr) {
    if (arr.length === 0) {
      return arr
    }
    return arr.sort((a, b) => a.attributes.no - b.attributes.no)
  }

  getState(fullStateName: string, mobileStateDif: string){
    if (mobileStateDif && (this.breakpoints.small || this.breakpoints.extraSmall)) {
      return mobileStateDif
    }
    let abbreviation = 'CA'
    if (this.breakpoints.small || this.breakpoints.extraSmall) {
      const fState = _.find(states, (x) => x.name === fullStateName)
      if (fState) {
        abbreviation = fState.abbreviation
      }
    }
    else{
      abbreviation = fullStateName
    }

    return abbreviation
  }

  openLicense(hasLicense, img?, state?){
    if(!hasLicense){
      return
    }
    this.showLicense.emit(true)
    this.imgUrl.emit(img.data[0].attributes.url)
    this.licenseState.emit(state)
  }
}
